import { createContext, useContext } from 'react';
import type { LabsContext } from './types';

export const LabsContextValue = createContext<LabsContext | null>(null);

export function useLabs(): LabsContext {
  const context = useContext(LabsContextValue);
  if (!context) throw new Error('useLabs must be used inside the Labs layout');
  return context;
}
